import React from 'react';
import styled from 'styled-components';

import Menu from 'antd/es/menu';

import featureToggles from 'config/featureToggles';

import Logo from './Logo';
import { useFeatureToggleItem } from 'components/FeatureToggle';
// import { Text } from 'components/Text';


const SideNavWrapper = styled.div`
  background-color: #fff;
  height: 100%;
  width: 100%;
  box-shadow: 1px 0px 0px #EFF2F5;
`;

const SideNavHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 16px 16px 28px
`;

// const SideNavLocationName = styled(Text)`
//   padding: 8px 4px;
//   padding-start: 32px;
//   font-weight: 500;
//   font-size: 12px;
//   line-height: 18px;
//   color: rgb(130, 140, 148);
// `;

const SideNavMenu = styled(Menu)`
  height: calc(100% - 101px);
  padding: 0 16px;
  border-right: unset;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;

  & > :last-child {
    margin-top: auto;
  }
`;

const SideNavItem = styled(Menu.Item)`
  font-size: 16px;
  border-radius: 8px;
  min-height: 40px;

  &.ant-menu-item-active {
    background: #FAFBFC;
  }

  &.ant-menu-item-selected {
    background: #F5FDFF !important;
    border-radius: 8px;
    font-weight: 600;
  }

  &::after {
    display: none;
  }
`;

const SideNavSubMenu = styled(Menu.SubMenu)`
  border-radius: 8px;
  margin-top: 4px;
  margin-bottom: 8px;

  & .ant-menu-submenu-title {
    border-radius: 8px;
    font-size: 16px;
    line-height: 24px;
    margin-top: unset;
    margin-bottom: unset;
  }

  & .ant-menu-submenu-title:active {
    &:not(.ant-menu-submenu-selected) {
      background: #FAFBFC;
    }
  }

  &.ant-menu-submenu-active {
    background: #FAFBFC;

    & .ant-menu-submenu-title {
      border-radius: 8px; 
    }
  }

  &.ant-menu-submenu-selected {
    background: #F5FDFF;
    & > *, .ant-menu-item-active {
      background: #F5FDFF;
    }
  }

  & .ant-menu-submenu-arrow {
    color: #DAE0E6;
  }

  &.ant-menu-submenu-open {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    background: #FAFBFC;

    &:not(.ant-menu-submenu-selected) > * {
      background: #FAFBFC;
    }

    & > *:first-child {
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
    }

    & > *:last-child {
      border-bottom-left-radius: 8px;
      border-bottom-right-radius: 8px;
    }
  }

  & ul > * {
    margin-top: 0px !important;
    margin-bottom: 0px !important;
    line-height: 36px !important;
    text-indent: 10px;

    &:last-child {
      margin-bottom: 4px !important;
    }
  }
`;

const SideNavGroup = styled(Menu.ItemGroup)`
  & .ant-menu-item-group-title {
    font-weight: 600;
    font-size: 12px;
    line-height: 20px;
    color: #B9C2C9;
    padding: 8px 0px 0px 16px;
  }
`;

const SideNav = ({ menu = [], selectedMenuItemKey, onSelectedMenuItemChanged, locationInfo }) => {
  console.log(locationInfo)
  return (
    <SideNavWrapper>
      <SideNavHeader>
        <Logo to="/" style={{ height: '31px' }} />
        {/* <SideNavLocationName>
          {locationInfo && locationInfo.location_name}
        </SideNavLocationName> */}
      </SideNavHeader>
      {selectedMenuItemKey !== null ? <SideNavMenu
        inlineIndent={16}
        defaultSelectedKeys={[selectedMenuItemKey]}
        defaultOpenKeys={[selectedMenuItemKey.split('.')[0]]}
        forceSubMenuRender={true}
        mode="inline"
        onSelect={(data) => {
          if (typeof onSelectedMenuItemChanged === 'function')
            onSelectedMenuItemChanged(data);
        }}
      >
        {Object.keys(menu).map(key => renderSideNavItem(menu[key], key))}
      </SideNavMenu> : null}
    </SideNavWrapper>
  );
};

const FeatureToggleMainMenuItem = ({ itemKey, children, fallback = null, ...rest }) => {
  const featureToggle = useFeatureToggleItem(`${featureToggles.MAIN_MENU}.${itemKey}`);

  if (featureToggle) {
    if (featureToggle.visible === false) {
      return null;
    }
  }

  return React.cloneElement(children, rest);
};

const renderSideNavItem = (menuItem, menuItemKey, menuItemParentPath = '') => {
  const type = menuItem.type || 'item';

  switch (type) {
    case 'item': return (
      <FeatureToggleMainMenuItem key={menuItemKey} itemKey={menuItemKey}>
        <SideNavItem
          key={menuItemKey}
          icon={menuItem.icon}
          path={[menuItemParentPath, menuItem.to].join('')}
          disabled={menuItem.disabled || false}
        >
          {menuItem.label}
        </SideNavItem>
      </FeatureToggleMainMenuItem>
    );

    case 'sub': return (
      <FeatureToggleMainMenuItem key={menuItemKey} itemKey={menuItemKey}>
        <SideNavSubMenu key={menuItemKey} icon={menuItem.icon} title={menuItem.label}>
          {Object.keys(menuItem.items).map(key =>
            renderSideNavItem(
              menuItem.items[key],
              [menuItemKey, key].join('.'),
              [menuItemParentPath, menuItem.to || ''].join(''),
            )
          )}
        </SideNavSubMenu>
      </FeatureToggleMainMenuItem>
    );

    case 'section': return (
      <FeatureToggleMainMenuItem key={menuItemKey} itemKey={menuItemKey}>
        <SideNavGroup key={menuItemKey} title={menuItem.label} icon={menuItem.icon}>
          {Object.keys(menuItem.items).map(key =>
            renderSideNavItem(
              menuItem.items[key],
              [menuItemKey, key].join('.'),
              [menuItemParentPath, menuItem.to || ''].join(''),
            )
          )}
        </SideNavGroup>
      </FeatureToggleMainMenuItem>
    );

    default:
      return null;
  }
};

export default SideNav;